import tw from 'tailwind-styled-components'

export const TwPinStickerMenu = tw.div`
  min-w-190
`

export const TwHeader = tw.div`
  flex
  items-center
  font-semibold
  px-8
  h-32
  bg-header-old
  text-main-old
  cursor-default

  border-0
  border-b-1
  border-solid
  border-main-old
`

export const TwStickersList = tw.div`
  flex
  flex-col
  max-h-[360px]
`

export const TwStickerWrapper = tw.div`
  group
  min-h-32
  px-4
  flex
  items-center
  gap-4
  cursor-pointer
  hover:bg-action-default
`

export const TwStickerTitle = tw.span`
  text-14
  text-main-old
  group-hover:text-on-color
  max-w-160
  truncate
`
